import { render, staticRenderFns } from "./ContentDetailsModal.vue?vue&type=template&id=1aadde72&scoped=true&"
import script from "./ContentDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ContentDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aadde72",
  null
  
)

export default component.exports